export default __webpack_public_path__ + "static/media/category_01.57f8e63a.jpg";